import {NOTIFY, CLEAR_NOTIFICATION} from './notification-actions';

// id: null,
// message: null,
// type: 'info',
// duration: 3000,
// showClose: true,
// autoClose: true,
// onHidden: null

export default function notification(state = null, {type, payload}) {
    switch (type) {
        case NOTIFY: {
            return {
                ...state,
                ...payload,
            };
        }

        case CLEAR_NOTIFICATION: {
            return null;
        }

        default:
            return state;
    }
}
